import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import {Observable, Subject, of, takeUntil} from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { InitialDataService } from 'src/app/services/initialData.service';
import { OverlaysService } from 'src/app/services/overlays.service';
import { SanitizeService } from 'src/app/services/sanitize.service';

@Component({
  selector: 'app-newsletter-modal',
  templateUrl: './newsletter-modal.component.html',
  styleUrls: ['./newsletter-modal.component.scss'],
})
export class NewsletterModalComponent implements OnInit {
    private destroy$ = new Subject<void>();
  newsletterConfiguration$: Observable<any>;

  newsletterForm: FormGroup;
  onSubmit$$: Subject<FormGroup> = new Subject();

  constructor(
    private http: HttpClient,
    private overlaysService: OverlaysService,
    private translateService: TranslateService,
    private fb: FormBuilder,
    public modalController: ModalController,
    private initialDataService: InitialDataService,
    public sanitizeService: SanitizeService
  ) {
    this.newsletterForm = this.fb.group({
      name: ['', Validators.required],
      surname: ['', Validators.required],
      email: ['', Validators.compose([Validators.required, Validators.email])],
      zipCode: ['', Validators.required],
      phone: [],
      privacyPolicy: [false, Validators.compose([Validators.requiredTrue])],
    });


  }

  ngOnInit() {
    this.newsletterConfiguration$ = this.initialDataService.newsletterConfiguration$;

      this.onSubmit$$
          .pipe(
              takeUntil(this.destroy$),
              this.overlaysService.processForm$(),
              this.overlaysService.presentLoader$(),
              switchMap((form: FormGroup) =>
                  this.http.post(`/newsletter-subscribe`, this.getFormData(form)).pipe(
                      catchError((error) => {
                          this.overlaysService.dismissIonicLoader();
                          this.overlaysService.presentInfoAlert(error, 'ALERTS.ERROR');
                          return of();
                      })
                  )
              )
          )
          .subscribe(
              () => {
                  this.overlaysService.dismissIonicLoader();
                  this.modalController.dismiss();
                  this.overlaysService.presentInfoAlert(
                      this.translateService.instant('LANDING.MODAL_SUCCESS_NEWSLETTER_TEXT')
                  );
              }
          );
  }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

  dismiss() {
    this.modalController.dismiss({
      dismissed: true,
    });
  }

  getFormData = (form: FormGroup) => {
    const formData = new FormData();

    for (const [key, value] of Object.entries(form)) {
      formData.set(key, value);
    }

    return formData;
  };

  resolved($event) {}
}
